import { useLayer } from '@coursera-web/statsig';

import {
  EDIT_GOAL_ENABLED_URL,
  EDIT_GOAL_REDIRECT_LAYER,
  EDIT_GOAL_REDIRECT_URL,
} from 'bundles/personalization-settings/constants';

/**
 * Whether the edit goal redirect is for onboarding or to personalization settings
 * When skip is true, then will always be false and we will skip the impression
 */
export const useIsEditGoalRedirectEnabled = ({ skip }: { skip: boolean }): boolean => {
  const layer = useLayer(EDIT_GOAL_REDIRECT_LAYER);

  if (skip) return false;

  const editGoalUrl = layer.get(EDIT_GOAL_REDIRECT_URL, 'onboarding');

  return editGoalUrl === EDIT_GOAL_ENABLED_URL;
};
